import { render, staticRenderFns } from "./ModalNuevoReporte.vue?vue&type=template&id=6bb0b1bd&scoped=true&"
import script from "./ModalNuevoReporte.vue?vue&type=script&lang=ts&"
export * from "./ModalNuevoReporte.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb0b1bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6bb0b1bd', component.options)
    } else {
      api.reload('6bb0b1bd', component.options)
    }
    module.hot.accept("./ModalNuevoReporte.vue?vue&type=template&id=6bb0b1bd&scoped=true&", function () {
      api.rerender('6bb0b1bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/MedioAmbiente/Reporte/ModalNuevoReporte.vue"
export default component.exports